import dateTimeUtils from '../../utils/dateTime.utils';
import { Loan } from '../../types/loan/Loan';
import { LoanStatus } from '../../types/loan/LoanStatus';

// A loan is considered "new" for 24 business hours after it is published
// (weekend days are not counted towards the window).
const newWindowBusinessHours = 24;

interface LoanMonitorNewLabelProps {
    loan: Loan;
}

export function LoanMonitorNewLabel({ loan }: LoanMonitorNewLabelProps) {
    if(loan.status !== LoanStatus.Active) return null;

    const businessHoursSincePublished = loan.publishedDate
        ? dateTimeUtils.businessHoursSince(loan.publishedDate, newWindowBusinessHours)
        : undefined;
    const isNew = businessHoursSincePublished != null
        && businessHoursSincePublished < newWindowBusinessHours;

    return isNew ? <span className="state-new">NEW</span> : null;
}
